var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop / Search Form",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-682 -452)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 5",
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-279.453 -131.712C-208.767 -168.183 97.8459 -115.897 403.045 -143.604C519.215 -154.151 631.548 -167.401 741.047 -131.712C947.296 -64.4907 799.798 136.625 697.999 307.974C502.99 636.218 -254.318 192.768 -254.318 192.768C-254.318 -0.523807 -350.139 -95.2417 -279.453 -131.712Z",
    fill: "url(#paint0_angular_0_1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 277132237"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -85,
    y: -89,
    width: 734,
    height: 334,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 277132242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 277132241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 277132240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 8",
    d: "M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
    stroke: "#374151"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: -605.457,
    y: -455,
    width: 1750.39,
    height: 1184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.74758 82.3555) rotate(66.8355) scale(368.149 688.957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0242743,
    stopColor: "#ABE1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446559,
    stopColor: "#80CDD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625961,
    stopColor: "#7C9CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830113,
    stopColor: "#7EA3E6",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947316,
    stopColor: "#CFEEBB",
    stopOpacity: 0.881587
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-682 -452)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircle);
export default __webpack_public_path__ + "static/media/icon-circle.7c8daa725a6590fc5744148ed123a208.svg";
export { ForwardRef as ReactComponent };